'use strict';

var _ = require('lodash');
var FaresOptimizerPagerService = function FaresOptimizerPagerService() {
  var MAX_NUMBER_OF_PAGES_TO_DISPLAY = 9;
  var START_PAGE_OF_DEFAULT_PAGES = 2;
  var MIDDLE_PAGE_OF_DEFAULT_PAGES = 5;
  var END_PAGE_OF_DEFAULT_PAGES = 8;
  function getPager(pageSize, totalPages) {
    var numberOfPagesDisplayed = totalPages > MAX_NUMBER_OF_PAGES_TO_DISPLAY ? MAX_NUMBER_OF_PAGES_TO_DISPLAY : totalPages;
    var pages = updateDisplayedPages(totalPages, numberOfPagesDisplayed, 1);
    return {
      currentPage: 1,
      pageSize: pageSize,
      totalPages: totalPages,
      numberOfPagesDisplayed: numberOfPagesDisplayed,
      pages: pages,
      disableFirstPageBtn: false,
      disablePreviousPageBtn: false,
      disableNextPageBtn: false,
      disableLastPageBtn: false,
      ellipsisBeforeCurrentPage: false,
      ellipsisAfterCurrentPage: false,
      selectedPageToGo: ''
    };
  }
  function updatePagerUponPageChange(pager, pageNumber, selectedPage) {
    pager.selectedPageToGo = pager.selectedPageToGo === pageNumber ? pageNumber : '';
    pager.currentPage = selectedPage;
    pager.pages = updateDisplayedPages(pager.totalPages, pager.numberOfPagesDisplayed, pager.currentPage);
    pager.ellipsisBeforeCurrentPage = getEllipsisBeforeCurrentPage(pager);
    pager.ellipsisAfterCurrentPage = getEllipsisAfterCurrentPage(pager);
    updateButtonsState(pager, selectedPage);
  }
  function updateDisplayedPages(totalPages, numberOfPagesDisplayed, currentPage) {
    var pages = [];
    if (totalPages > 1) {
      if (totalPages <= numberOfPagesDisplayed) {
        pages = _.range(START_PAGE_OF_DEFAULT_PAGES, totalPages);
      } else {
        if (currentPage <= MIDDLE_PAGE_OF_DEFAULT_PAGES) {
          pages = _.range(START_PAGE_OF_DEFAULT_PAGES, END_PAGE_OF_DEFAULT_PAGES);
        } else if (currentPage + (START_PAGE_OF_DEFAULT_PAGES + 1) >= totalPages - 1) {
          pages = _.range(totalPages - (MIDDLE_PAGE_OF_DEFAULT_PAGES + 1), totalPages);
        } else {
          pages = _.range(currentPage - START_PAGE_OF_DEFAULT_PAGES, currentPage + (START_PAGE_OF_DEFAULT_PAGES + 1));
        }
      }
    }
    return pages;
  }
  function getEllipsisBeforeCurrentPage(pager) {
    return pager.pages.length <= MIDDLE_PAGE_OF_DEFAULT_PAGES + 1 && pager.totalPages > pager.numberOfPagesDisplayed && pager.currentPage > MIDDLE_PAGE_OF_DEFAULT_PAGES;
  }
  function getEllipsisAfterCurrentPage(pager) {
    return pager.pages.length <= MIDDLE_PAGE_OF_DEFAULT_PAGES + 1 && pager.totalPages > pager.numberOfPagesDisplayed && pager.currentPage <= pager.totalPages - MIDDLE_PAGE_OF_DEFAULT_PAGES;
  }
  function updateButtonsState(pager, selectedPage) {
    if (selectedPage === 1) {
      pager.disableFirstPageBtn = true;
      pager.disablePreviousPageBtn = true;
    } else {
      pager.disableFirstPageBtn = false;
      pager.disablePreviousPageBtn = false;
    }
    if (selectedPage === pager.totalPages) {
      pager.disableLastPageBtn = true;
      pager.disableNextPageBtn = true;
    } else {
      pager.disableLastPageBtn = false;
      pager.disableNextPageBtn = false;
    }
  }
  return {
    getPager: getPager,
    updatePagerUponPageChange: updatePagerUponPageChange
  };
};
FaresOptimizerPagerService.$inject = [];
module.exports = FaresOptimizerPagerService;